var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyCrypto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 14.5013V9.5013M13.3332 12.0013H18.3332M18.3332 5.33464H1.6665M18.3332 7.0013V3.83464C18.3332 2.90122 18.3332 2.43451 18.1515 2.07799C17.9917 1.76438 17.7368 1.50941 17.4232 1.34963C17.0666 1.16797 16.5999 1.16797 15.6665 1.16797H4.33317C3.39975 1.16797 2.93304 1.16797 2.57652 1.34962C2.26292 1.50941 2.00795 1.76438 1.84816 2.07798C1.6665 2.4345 1.6665 2.90121 1.6665 3.83464V10.168C1.6665 11.1014 1.6665 11.5681 1.84816 11.9246C2.00795 12.2382 2.26292 12.4932 2.57652 12.653C2.93304 12.8346 3.39975 12.8346 4.33317 12.8346H9.99984",
    stroke: "#C4F538",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyCrypto);
export default __webpack_public_path__ + "static/media/buy-crypto.a4628696b6389c967783ebc938c9d5c2.svg";
export { ForwardRef as ReactComponent };